import React from 'react';
import { VStack } from '@chakra-ui/react';
import ItemCard from './item-card';
import { Content, Favorite, FieldOption } from '@/lib/types';

interface FilterConfig {
  label: string;
  id: string;
  key: string;
  options: FieldOption[];
}

type Props = {
  contents: Content[];
  favorites: { [key: number]: Favorite };
  viewMode: 'list' | 'grid';
  viewFavorites: boolean;
  // Accepted for symmetry with ItemGrid; the list view does not render
  // dropdown-field pills (those are grid-only).
  filterConfig?: FilterConfig[];
  lastContentElementRef: (node: HTMLDivElement | null) => void;
  onView: (item: Content) => void;
  onFavourite: (item: Content) => void;
  onGeneratePiblicLink: (item: Content) => void;
  onDuplicate: (item: Content) => void;
  onEdit: (item: Content) => void;
  onDelete: (item: Content) => void;
  onChangeStatus: (item: Content, status: 'draft' | 'published') => void;
  onPrint: (item: Content) => void;
};

const ItemList: React.FC<Props> = ({
  contents,
  favorites,
  viewMode,
  viewFavorites,
  filterConfig,
  lastContentElementRef,
  onView,
  onFavourite,
  onGeneratePiblicLink,
  onDuplicate,
  onEdit,
  onDelete,
  onChangeStatus,
  onPrint,
}) => {
  return (
    <VStack gap={0} align={'stretch'}>
      {contents.map((item, index) =>
        viewFavorites && !favorites[item.id] ? null : (
          <ItemCard
            key={`index-${index}-${item.reference_id}`}
            lastContentElementRef={lastContentElementRef}
            item={item}
            favorites={favorites}
            viewMode={viewMode}
            filterConfig={filterConfig}
            onView={onView}
            onFavourite={onFavourite}
            onGeneratePiblicLink={onGeneratePiblicLink}
            onDuplicate={onDuplicate}
            onEdit={onEdit}
            onDelete={onDelete}
            onChangeStatus={onChangeStatus}
            onPrint={onPrint}
          />
        ),
      )}
    </VStack>
  );
};

export default ItemList;
